
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.725 1.115C13.427-.185 12.452.01 12.452.01L7.006 5.457.909 11.553 0 15.839l4.287-.91 6.096-6.093 5.447-5.447s.194-.975-1.105-2.274zm-10.693 13.3l-1.462.315a3.339 3.339 0 00-.62-.839 3.37 3.37 0 00-.84-.622l.316-1.46.423-.423s.794.017 1.693.915c.897.896.914 1.693.914 1.693l-.424.42z","fill":"#B1B7C7"}})])
          )
        }
      }
    